import styled from "styled-components/macro";

export const TableBodyStyled = styled.tbody``;
